import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const BUILDER_URL = "/coaching-portal/custom-workflows/automations";

// What stops the automation from being turned on, and what would improve it without stopping it
const FixBanner = ({ automationId, issues, suggestions }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) => t(`emailAutomations.builder.fix.${key}`, params);
  if (issues.length === 0) return null;

  return (
    <div className="ab-fix" role="alert">
      <span className="ab-fix__icon">
        <SvgIcon
          src="/img/new-icons/warning-white.svg"
          useCurrentColor
          classNames="size-6 shrink-0"
          aria-hidden="true"
        />
      </span>
      <strong>{tr("title", { count: issues.length })}</strong>
      <ul>
        {issues.map((issue) => (
          <li key={`${issue.code}-${issue.stepPosition ?? "x"}`}>
            {issue.stepPosition === undefined ? (
              tr(`issue.${issue.code}`)
            ) : (
              <a
                href={`${BUILDER_URL}/${automationId}?step=${issue.stepPosition}`}
              >
                {tr("emailStep")} · {tr(`issue.${issue.code}`)}
              </a>
            )}
          </li>
        ))}
      </ul>
      {suggestions.length > 0 ? (
        <div className="ab-fix__suggestions">
          <small>{tr("suggestions")}</small>
          {suggestions.map((suggestion) => (
            <p key={`${suggestion.code}-${suggestion.stepPosition}`}>
              {tr(`suggestion.${suggestion.code}`, {
                email: suggestion.systemEmail?.name,
              })}{" "}
              <a
                href={`${BUILDER_URL}/${automationId}?step=${suggestion.stepPosition}`}
              >
                {tr("goToStep")}
              </a>
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
};

FixBanner.propTypes = {
  automationId: PropTypes.string.isRequired,
  issues: PropTypes.array.isRequired,
  suggestions: PropTypes.array.isRequired,
};

export default FixBanner;
